export type CategoryKey = 'drone' | 'operator' | 'robot'

export interface CategoryTheme {
  key: CategoryKey
  viewerTheme: 'green' | 'purple' | 'orange'
  headerGradient: string
  filterLabelText: string
  filterCardBorder: string
  selectBorder: string
  selectFocus: string
  selectHover: string
  selectActive: string
  selectHoverBg: string
  summaryBg: string
  summaryText: string
  summaryBorder: string
  listSelected: string
  thumbSelected: string
  iconColor: string
  spinner: string
  countLabel: string
  title: (t: any) => string
  badgeGradient: string
  inputFocus: string
}

export const CATEGORY_THEMES: Record<CategoryKey, CategoryTheme> = {
  operator: {
    key: 'operator',
    viewerTheme: 'purple',
    headerGradient: 'bg-gradient-to-r from-purple-50 to-violet-50',
    filterLabelText: 'text-purple-800',
    filterCardBorder: 'border-purple-200',
    selectBorder: 'border-purple-300',
    selectFocus: 'focus:ring-purple-400/50 focus:border-purple-500',
    selectHover: 'hover:border-purple-400',
    selectActive: 'bg-purple-100 text-purple-700 font-semibold',
    selectHoverBg: 'hover:bg-purple-50',
    summaryBg: 'bg-gradient-to-r from-purple-100 to-violet-100',
    summaryText: 'text-purple-800',
    summaryBorder: 'border-purple-200',
    listSelected: 'bg-purple-100 border border-purple-300',
    thumbSelected: 'bg-purple-50 border-purple-300',
    iconColor: 'text-purple-600',
    spinner: 'text-purple-600',
    countLabel: 'operatör fotoğrafı',
    title: (t: any) => t.operatorPhotos,
    badgeGradient: 'from-purple-400 to-purple-600',
    inputFocus: 'focus:ring-2 focus:ring-purple-500 focus:border-transparent'
  },
  drone: {
    key: 'drone',
    viewerTheme: 'green',
    headerGradient: 'bg-gradient-to-r from-green-50 to-emerald-50/50',
    filterLabelText: 'text-green-800',
    filterCardBorder: 'border-green-200',
    selectBorder: 'border-green-300',
    selectFocus: 'focus:ring-green-400/50 focus:border-green-500',
    selectHover: 'hover:border-green-400',
    selectActive: 'bg-green-100 text-green-700 font-semibold',
    selectHoverBg: 'hover:bg-green-50',
    summaryBg: 'bg-gradient-to-r from-green-100 to-emerald-100',
    summaryText: 'text-green-800',
    summaryBorder: 'border-green-200',
    listSelected: 'bg-green-100 border border-green-300',
    thumbSelected: 'bg-green-50 border-green-300',
    iconColor: 'text-green-600',
    spinner: 'text-green-600',
    countLabel: 'drone fotoğrafı',
    title: (t: any) => t.dronePhotos,
    badgeGradient: 'from-green-400 to-emerald-600',
    inputFocus: 'focus:ring-2 focus:ring-green-500 focus:border-transparent'
  },
  robot: {
    key: 'robot',
    viewerTheme: 'orange',
    headerGradient: 'bg-gradient-to-r from-orange-50 to-amber-50/50',
    filterLabelText: 'text-orange-800',
    filterCardBorder: 'border-orange-200',
    selectBorder: 'border-orange-300',
    selectFocus: 'focus:ring-orange-400/50 focus:border-orange-500',
    selectHover: 'hover:border-orange-400',
    selectActive: 'bg-orange-100 text-orange-700 font-semibold',
    selectHoverBg: 'hover:bg-orange-50',
    summaryBg: 'bg-gradient-to-r from-orange-100 to-amber-100',
    summaryText: 'text-orange-800',
    summaryBorder: 'border-orange-200',
    listSelected: 'bg-orange-100 border border-orange-300',
    thumbSelected: 'bg-orange-50 border-orange-300',
    iconColor: 'text-orange-600',
    spinner: 'text-orange-600',
    countLabel: 'robot fotoğrafı',
    title: (t: any) => t.robotPhotos,
    badgeGradient: 'from-orange-500 to-amber-600',
    inputFocus: 'focus:ring-2 focus:ring-orange-500 focus:border-transparent'
  }
}
